<template>
  <div ref="container" @dblclick="fullscreenSwich"
       style="width:100%;height:100%;background-color: #000000;margin:0 auto;">
    <div class="buttons-box" id="buttonsBox">
      <div class="buttons-box-left">
        <i v-if="!playing" class="iconfont icon-play jessibuca-btn" @click="playBtnClick"></i>
        <i v-if="playing" class="iconfont icon-pause jessibuca-btn" @click="pause"></i>
        <i class="iconfont icon-stop jessibuca-btn" @click="destroy"></i>
        <i v-if="isNotMute" class="iconfont icon-audio-high jessibuca-btn" @click="mute()"></i>
        <i v-if="!isNotMute" class="iconfont icon-audio-mute jessibuca-btn" @click="cancelMute()"></i>
      </div>
      <div class="buttons-box-right">
        <span class="jessibuca-btn">{{ kBps }} kb/s</span>
        <!--          <i class="iconfont icon-file-record1 jessibuca-btn"></i>-->
        <!--          <i class="iconfont icon-xiangqing2 jessibuca-btn" ></i>-->
        <i class="iconfont icon-camera1196054easyiconnet jessibuca-btn" @click="screenshot"
           style="font-size: 1rem !important"></i>
        <i class="iconfont icon-shuaxin11 jessibuca-btn" @click="playBtnClick"></i>

        <!-- 对讲按钮 -->
        <i v-if="canTalk && !talkStatus"
           class="iconfont icon-dianhua01 jessibuca-btn"
           @click="talkHandle"
           :title="talkTitle"
           :style="{ color: 'rgba(255, 255, 255, 1)' }"></i>
        <i v-if="talkStatus"
           class="iconfont icon-dianhua01 jessibuca-btn"
           @click="talkHandle"
           title="停止对讲"
           :style="{ color: microphoneStatus ? 'rgba(255,140,140,0.77)' : 'rgba(113,250,104,0.69)' }"></i>

        <!-- 云台控制按钮 -->
        <i title="云台控制" class="iconfont icon-shezhi1 jessibuca-btn" @click="togglePtzControl"></i>

        <i v-if="!fullscreen" class="iconfont icon-weibiaoti10 jessibuca-btn" @click="fullscreenSwich"></i>
        <i v-if="fullscreen" class="iconfont icon-weibiaoti11 jessibuca-btn" @click="fullscreenSwich"></i>
      </div>
    </div>

    <!-- 云台控制面板 -->
    <div v-show="showPtzControls" class="ptz-control-panel">
      <div class="ptz-dpad">
        <div class="ptz-control-btn ptz-up" @mousedown="ptzCamera('up')" @mouseup="ptzCamera('stop')">
          <i class="el-icon-caret-top"></i>
        </div>
        <div class="ptz-control-btn ptz-left" @mousedown="ptzCamera('left')" @mouseup="ptzCamera('stop')">
          <i class="el-icon-caret-left"></i>
        </div>
        <div class="ptz-control-btn ptz-down" @mousedown="ptzCamera('down')" @mouseup="ptzCamera('stop')">
          <i class="el-icon-caret-bottom"></i>
        </div>
        <div class="ptz-control-btn ptz-right" @mousedown="ptzCamera('right')" @mouseup="ptzCamera('stop')">
          <i class="el-icon-caret-right"></i>
        </div>
        <div class="ptz-control-center">
          <i class="fa fa-pause-circle"></i>
        </div>
      </div>
      <!-- 速度控制区 -->
      <div class="ptz-speed-section">
        <div class="ptz-speed-header">
          <span class="ptz-speed-label">速度</span>
          <span class="ptz-speed-value">{{ ptzSpeed }}</span>
        </div>
        <div class="ptz-speed-presets">
          <button class="speed-preset-btn" :class="{ active: ptzSpeed <= 40 }" @click="ptzSpeed = 20">慢</button>
          <button class="speed-preset-btn" :class="{ active: ptzSpeed > 40 && ptzSpeed < 150 }" @click="ptzSpeed = 120">中</button>
          <button class="speed-preset-btn" :class="{ active: ptzSpeed >= 150 && ptzSpeed < 230 }" @click="ptzSpeed = 200">快</button>
          <button class="speed-preset-btn" :class="{ active: ptzSpeed >= 230 }" @click="ptzSpeed = 255">极速</button>
        </div>
        <el-slider v-model="ptzSpeed" :max="255" :min="1" :step="5" style="width: 100%;"></el-slider>
      </div>
    </div>
  </div>
</template>

<script>
let jessibucaPlayer = {};
export default {
  name: 'jessibuca',
  data() {
    return {
      playing: false,
      isNotMute: false,
      quieting: false,
      fullscreen: false,
      loaded: false, // mute
      speed: 0,
      performance: "", // 工作情况
      kBps: 0,
      btnDom: null,
      videoInfo: null,
      volume: 1,
      rotate: 0,
      vod: true, // 点播
      forceNoOffscreen: false,

      // 新增云台和对讲相关数据
      showPtzControls: false,
      ptzSpeed: 120,  // 默认速度从30提升到120（范围0-255）
      talkStatus: false,
      microphoneStatus: false,
      talkTitle: "开始对讲",
      talkInterval: null,
      zlmRTCClient: null,
      broadCastModel: '0', // 默认国标对讲模式
    };
  },
  props: {
    videoUrl: {},
    error: {},
    height: {},
    hasAudio: {},
    deviceId: {},
    channelId: {},
    // 内置加载提示文案；外层若已有自定义加载层，可传空字符串关闭，避免提示重叠
    loadingText: {
      type: String,
      default: "请稍等, 视频加载中......"
    }
  },
  mounted() {
    window.onerror = (msg) => {
      // console.error(msg)
    };
    console.log(this._uid)
    let paramUrl = decodeURIComponent(this.$route.params.url)
    this.$nextTick(() => {
      requestAnimationFrame(() => {
        this.updatePlayerDomSize()
      })
      window.onresize = () => {
        requestAnimationFrame(() => {
          this.updatePlayerDomSize()
        })
      }
      if (typeof (this.videoUrl) == "undefined") {
        this.videoUrl = paramUrl;
      }
      this.btnDom = document.getElementById("buttonsBox");
      console.log("初始化时的地址为: " + this.videoUrl)
      this.play(this.videoUrl)
    })
  },
  watch: {
    videoUrl: {
      handler(newData) {
        this.play(newData)
      }
    }
  },
  methods: {
    updatePlayerDomSize() {
      let dom = this.$refs.container;
      if (!dom || !dom.parentNode) return;
      let parent = dom.parentNode;
      dom.style.width = parent.clientWidth + 'px';
      dom.style.height = parent.clientHeight + 'px';
    },
    create() {
      let options = {};
      console.log("hasAudio  " + this.hasAudio)

      jessibucaPlayer[this._uid] = new window.Jessibuca(Object.assign(
        {
          container: this.$refs.container,
          autoWasm: true,
          background: "",
          controlAutoHide: false,
          debug: false,
          decoder: "static/js/jessibuca/decoder.js",
          forceNoOffscreen: true,
          hasAudio: typeof (this.hasAudio) == "undefined" ? true : this.hasAudio,
          hasVideo: true,
          heartTimeout: 5,
          heartTimeoutReplay: true,
          heartTimeoutReplayTimes: 3,
          hiddenAutoPause: false,
          hotKey: false,
          isFlv: false,
          isFullResize: false,
          isNotMute: this.isNotMute,
          isResize: false,
          keepScreenOn: false,
          loadingText: this.loadingText,
          loadingTimeout: 10,
          loadingTimeoutReplay: true,
          loadingTimeoutReplayTimes: 3,
          openWebglAlignment: false,
          operateBtns: {
            fullscreen: false,
            screenshot: false,
            play: false,
            audio: false,
            record: false
          },
          recordType: "webm",
          rotate: 0,
          showBandwidth: false,
          supportDblclickFullscreen: false,
          timeout: 10,
          useMSE: location.hostname !== "localhost" && location.protocol !== "https:",
          useOffscreen: false,
          useWCS: location.hostname === "localhost" || location.protocol === "https",
          useWebFullScreen: false,
          videoBuffer: 0,
          wasmDecodeAudioSyncVideo: true,
          wasmDecodeErrorReplay: true,
          wcsUseVideoRender: true
        },
        options
      ));
      let jessibuca = jessibucaPlayer[this._uid];
      let _this = this;
      jessibuca.on("load", function () {
        console.log("on load init");
      });

      jessibuca.on("log", function (msg) {
        console.log("on log", msg);
      });
      jessibuca.on("record", function (msg) {
        console.log("on record:", msg);
      });
      jessibuca.on("pause", function () {
        _this.playing = false;
      });
      jessibuca.on("play", function () {
        _this.playing = true;
        _this.$emit('play');
      });
      jessibuca.on("fullscreen", function (msg) {
        console.log("on fullscreen", msg);
        _this.fullscreen = msg
      });

      jessibuca.on("mute", function (msg) {
        console.log("on mute", msg);
        _this.isNotMute = !msg;
      });
      jessibuca.on("audioInfo", function (msg) {
        console.log("audioInfo", msg);
      });

      jessibuca.on("bps", function (bps) {
        // console.log('bps', bps);

      });
      let _ts = 0;
      jessibuca.on("timeUpdate", function (ts) {
        // console.log('timeUpdate,old,new,timestamp', _ts, ts, ts - _ts);
        _ts = ts;
      });

      jessibuca.on("videoInfo", function (info) {
        console.log("videoInfo", info);
      });

      jessibuca.on("error", function (error) {
        console.log("error", error);
        _this.$emit('error', error);
      });

      jessibuca.on("timeout", function () {
        console.log("timeout");
      });

      jessibuca.on('start', function () {
        console.log('start');
      })

      jessibuca.on("performance", function (performance) {
        let show = "卡顿";
        if (performance === 2) {
          show = "非常流畅";
        } else if (performance === 1) {
          show = "流畅";
        }
        _this.performance = show;
      });
      jessibuca.on('buffer', function (buffer) {
        // console.log('buffer', buffer);
      })

      jessibuca.on('stats', function (stats) {
        // console.log('stats', stats);
      })

      jessibuca.on('kBps', function (kBps) {
        _this.kBps = Math.round(kBps);
      });

      // 显示时间戳 PTS
      jessibuca.on('videoFrame', function () {

      })

      //
      jessibuca.on('metadata', function () {

      });
    },
    playBtnClick: function (event) {
      this.play(this.videoUrl)
    },
    play: function (url) {
      console.log(url)
      // 容器未就绪时直接返回，避免 "Jessibuca need container option"
      // （组件 mounted 后或 videoUrl 变化时一定会再次触发 play）
      if (!this.$refs.container) return;
      if (jessibucaPlayer[this._uid]) {
        this.destroy();
      }
      this.create();
      jessibucaPlayer[this._uid].on("play", () => {
        this.playing = true;
        this.loaded = true;
        this.quieting = jessibuca.quieting;
      });
      if (jessibucaPlayer[this._uid].hasLoaded()) {
        jessibucaPlayer[this._uid].play(url);
      } else {
        jessibucaPlayer[this._uid].on("load", () => {
          console.log("load 播放")
          jessibucaPlayer[this._uid].play(url);
        });
      }
    },
    pause: function () {
      if (jessibucaPlayer[this._uid]) {
        jessibucaPlayer[this._uid].pause();
      }
      this.playing = false;
      this.err = "";
      this.performance = "";
    },
    screenshot: function () {
      if (jessibucaPlayer[this._uid]) {
        jessibucaPlayer[this._uid].screenshot();
      }
    },
    mute: function () {
      if (jessibucaPlayer[this._uid]) {
        jessibucaPlayer[this._uid].mute();
      }
    },
    cancelMute: function () {
      if (jessibucaPlayer[this._uid]) {
        jessibucaPlayer[this._uid].cancelMute();
      }
    },
    destroy: function () {
      if (jessibucaPlayer[this._uid]) {
        jessibucaPlayer[this._uid].destroy();
      }
      if (this.$refs.container && document.getElementById("buttonsBox") == null && this.btnDom) {
        this.$refs.container.appendChild(this.btnDom)
      }
      jessibucaPlayer[this._uid] = null;
      this.playing = false;
      this.err = "";
      this.performance = "";
      this.$emit('destroy', this._uid);
    },
    eventcallbacK: function (type, message) {
      // console.log("player 事件回调")
      // console.log(type)
      // console.log(message)
    },
    fullscreenSwich: function () {
      let isFull = this.isFullscreen()
      jessibucaPlayer[this._uid].setFullscreen(!isFull)
      this.fullscreen = !isFull;
    },
    isFullscreen: function () {
      return document.fullscreenElement ||
        document.msFullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement || false;
    },

    // 新增云台控制相关方法
    togglePtzControl() {
      this.showPtzControls = !this.showPtzControls;
    },
    ptzCamera(command) {
      if (!this.deviceId || !this.channelId) {
        console.warn('设备ID或通道ID未设置');
        return;
      }

      this.$axios({
        method: 'post',
        url: './api/ptz/control/' + this.deviceId + '/' + this.channelId +
             '?command=' + command +
             '&horizonSpeed=' + this.ptzSpeed +
             '&verticalSpeed=' + this.ptzSpeed +
             '&zoomSpeed=' + this.ptzSpeed
      }).then(function (res) {
        // 云台控制响应处理
      }).catch(function (error) {
        console.error('云台控制失败:', error);
      });
    },

    // 新增对讲相关方法
    // setTalkParams(deviceId, channelId, hasAudio) {
    //   this.deviceId = deviceId;
    //   this.channelId = channelId;
    //   this.hasAudio = hasAudio;
    // },

    talkHandle() {
      if (!this.talkStatus && this.canTalk) {
        // 开始对讲
        this.startTalk();
      } else if (this.talkStatus) {
        // 停止对讲
        this.stopTalk();
      }
    },

    get canTalk() {
      var ishttps = 'https:' == document.location.protocol ? true : false;
      if (!ishttps || !this.hasAudio) {
        this.talkTitle = "由于浏览器安全策略本站必须得是https，并且开启通道音频选项才可以对讲";
        return false;
      }
      this.talkTitle = "开始对讲";
      return true;
    },

    startTalk() {
      if (!this.deviceId || !this.channelId) {
        console.warn('设备ID或通道ID未设置');
        return;
      }

      this.talkStatus = true;

      // 1. 获取webrtc推流地址
      this.$axios({
        method: 'get',
        url: `/api/talkback/getWebRtcAddr/${this.deviceId}/${this.channelId}`
      }).then(res => {
        if (res.data.code != 0) {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
          this.talkStatusChange();
          return;
        }

        let webRtcPushUrl = res.data.data.webRtcPushUrl;
        let app = res.data.data.app;
        let stream = res.data.data.stream;

        // 2. 创建WebRTC连接
        this.zlmRTCClient = new window.ZLMRTCClient.Endpoint({
          element: document.createElement('video'), // 创建临时元素
          debug: false,
          zlmsdpUrl: webRtcPushUrl,
          simulcast: false,
          useCamera: false,
          audioEnable: true,
          videoEnable: false,
          recvOnly: false,
          resolution: {w: 0, h: 0},
          usedatachannel: false,
        });

        this.zlmRTCClient.on(ZLMRTCClient.Events.WEBRTC_ICE_CANDIDATE_ERROR, (e) => {
          console.log('ICE 协商出错');
          this.$message({
            message: e.msg,
            type: "error",
          });
          this.talkStatusChange();
        });

        this.zlmRTCClient.on(ZLMRTCClient.Events.WEBRTC_OFFER_ANWSER_EXCHANGE_FAILED, (e) => {
          console.log('offer anwser 交换失败', e);
          this.$message({
            message: e.msg,
            type: "error",
          });
          if (e.msg === "already publishing") {
            this.webrtcStop();
          }
          this.talkStatusChange();
        });

        this.zlmRTCClient.on(ZLMRTCClient.Events.WEBRTC_ON_CONNECTION_STATE_CHANGE, (state) => {
          console.log('当前状态==>', state);
          if (state === "connected") {
            // 推流成功开始下发语音对讲指令
            this.$axios({
              method: 'get',
              url: `/api/talkback/start/${this.deviceId}/${this.channelId}/${app}/${stream}/${this.broadCastModel}`
            }).then(res => {
              if (res.data.code !== 0) {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.webrtcStop();
                this.talkStatusChange();
                return;
              } else {
                this.$message({
                  message: "开始对讲",
                  type: "success",
                });
                this.microphoneStatus = true;
                this.talkTitle = "停止对讲";
              }
            }).catch(error => {
              this.$message({
                message: "对讲指令下发失败",
                type: "error",
              });
              this.stopTalk();
            });
          } else if (state === "failed") {
            this.$message({
              message: "webrtc推流失败，请检查流媒体配置",
              type: "error",
            });
            this.talkStatusChange();
          }
        });

      }).catch(res => {
        this.talkStatusChange();
        this.$message({
          message: res,
          type: "error",
        });
      });
    },

    stopTalk() {
      if (this.zlmRTCClient) {
        // 先关闭WebRTC连接，触发ZLM的on_stream_changed hook
        this.webrtcStop();
        
        // 异步调用后端API清理状态（不阻塞UI）
        this.$axios({
          method: 'get',
          url: `/api/talkback/stop/${this.deviceId}/${this.channelId}`
        }).then(res => {
          console.log('停止对讲响应:', res.data);
        }).catch(error => {
          console.error('停止对讲请求失败:', error);
        });

        this.$message({
          message: "停止对讲",
          type: "success",
        });
        this.talkStatusChange();
      }
    },

    talkStatusChange() {
      this.talkTitle = "开始对讲";
      this.talkStatus = false;
      if (this.talkInterval != null) {
        clearInterval(this.talkInterval);
      }
      this.microphoneStatus = false;
    },

    webrtcStop() {
      if (this.zlmRTCClient) {
        this.zlmRTCClient.close();
        this.zlmRTCClient = null;
      }
    },

    // 添加一个统一的清理方法，在组件销毁前确保对讲被正确关闭
    beforeDestroyCleanup() {
      // 如果正在对讲，则先停止对讲
      if (this.talkStatus) {
        this.stopTalk();
      }
    }
  },
  // 在组件销毁前确保对讲被关闭
  beforeDestroy() {
    this.beforeDestroyCleanup();
  },
  destroyed() {
    this.beforeDestroyCleanup();
    if (jessibucaPlayer[this._uid]) {
      jessibucaPlayer[this._uid].destroy();
    }
    this.playing = false;
    this.loaded = false;
    this.performance = "";
    // 清理对讲相关资源
    if (this.talkInterval) {
      clearInterval(this.talkInterval);
    }
    this.webrtcStop();
  },
}
</script>

<style scoped>
.buttons-box {
  width: 100%;
  height: 28px;
  background-color: rgba(43, 51, 63, 0.7);
  position: absolute;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  left: 0;
  bottom: 0;
  user-select: none;
  z-index: 10;
}

.jessibuca-btn {
  width: 20px;
  color: rgb(255, 255, 255);
  line-height: 27px;
  margin: 0px 10px;
  padding: 0px 2px;
  cursor: pointer;
  text-align: center;
  font-size: 0.8rem !important;
}

.buttons-box-right {
  position: absolute;
  right: 0;
}

/* 新增云台控制面板样式 */
.ptz-control-panel {
  position: absolute;
  right: 10px;
  bottom: 40px;
  width: 180px;
  background: rgba(0, 0, 0, 0.75);
  border-radius: 8px;
  z-index: 100;
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  backdrop-filter: blur(6px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

/* 方向键区域 - 使用 Grid 布局，避免 absolute 定位错乱 */
.ptz-dpad {
  display: grid;
  grid-template-columns: 32px 32px 32px;
  grid-template-rows: 32px 32px 32px;
  gap: 4px;
  place-items: center;
  flex-shrink: 0;
}

.ptz-control-btn {
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.18);
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.85);
  transition: background 0.15s;
  user-select: none;
}

.ptz-control-btn:hover {
  background: rgba(255, 255, 255, 0.35);
}
.ptz-control-btn:active {
  background: rgba(64, 158, 255, 0.5);
}

.ptz-up {
  grid-column: 2;
  grid-row: 1;
}

.ptz-left {
  grid-column: 1;
  grid-row: 2;
}

.ptz-down {
  grid-column: 2;
  grid-row: 3;
}

.ptz-right {
  grid-column: 3;
  grid-row: 2;
}

.ptz-control-center {
  grid-column: 2;
  grid-row: 2;
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
}

/* 速度控制区 */
.ptz-speed-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.ptz-speed-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.ptz-speed-label {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
}

.ptz-speed-value {
  font-size: 13px;
  font-weight: bold;
  color: #409EFF;
  min-width: 24px;
  text-align: right;
}

/* 速度预设按钮 */
.ptz-speed-presets {
  display: flex;
  gap: 4px;
  width: 100%;
  margin-bottom: 2px;
}

.speed-preset-btn {
  flex: 1;
  height: 22px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.65);
  font-size: 11px;
  cursor: pointer;
  transition: all 0.15s;
  padding: 0 2px;
  font-family: inherit;
}

.speed-preset-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  color: rgba(255, 255, 255, 0.9);
}

.speed-preset-btn.active {
  background: rgba(64, 158, 255, 0.3);
  border-color: rgba(64, 158, 255, 0.5);
  color: #409EFF;
  font-weight: 600;
}

/* 面板内 slider 样式微调 */
.ptz-speed-section /deep/ .el-slider__runway {
  margin: 4px 0;
}
.ptz-speed-section /deep/ .el-slider__button {
  width: 12px;
  height: 12px;
  border-color: #409EFF;
}
</style>



// WEBPACK FOOTER //
// src/components/common/jessibuca.vue